import { styled } from "../../theme";
import { Media } from "../../types";

export const SubMenuStyle = styled.div`
  width: 100%;
  min-width: 100%;
  height: 100%;
  flex-grow: 1;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  @media (max-width: ${({ theme }) => theme.mobileFirst.breakPoint}) {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: initial;
    position: fixed;
    top: 5%;
  }
`;

export const SubMenuWrapper = styled.div`
  display: flex;
  width: calc(100vw * 0.82);
  box-sizing: border-box;
  justify-content: flex-end;
  @media (max-width: ${({ theme }) => theme.mobileFirst.breakPoint}) {
    height: initial;
    width: calc(100vw * 0.9);
    min-height: 73vh;
  }
`;

export const SubMenuSectionStyle = styled.div`
  box-sizing: border-box;
  max-width: 65%;
  display: flex;
  justify-content: flex-end;
  z-index: 9;
  @media (max-width: ${({ theme }) => theme.mobileFirst.breakPoint}) {
    max-width: 100%;
    width: 100%;
    /* height: initial; */
    min-height: 100%;
  }
`;
export const SubMenuContainerStyle = styled.div<{ bg: Media | string; autoWidth: number }>`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  box-sizing: border-box;
  width: ${({ autoWidth }) => `${autoWidth}px`};
  background: ${({ bg }) => (bg ? (typeof bg === "string" ? bg : `url("${bg.url}")`) : "none")};
  background-position: center;
  background-size: cover;
  height: 100%;
  position: relative;
  padding-left: 0.5em;
  padding-right: 0.5em;
  -webkit-box-shadow: 10px 10px 28px -4px rgba(0, 0, 0, 0.8);
  -moz-box-shadow: 10px 10px 28px -4px rgba(0, 0, 0, 0.8);
  box-shadow: 10px 10px 28px -4px rgba(0, 0, 0, 0.8);
  @media (max-width: ${({ theme }) => theme.mobileFirst.breakPoint}) {
    width: 100%;
    justify-content: flex-start;
    /* height: initial; */
  }
`;
export const SubMenuTitleContainerStyle = styled.div`
  font-size: 1.5em;
  width: 95%;
  padding-top: 1.2em;
  margin-left: auto;
  margin-right: auto;
  box-sizing: border-box;
  @media (max-width: ${({ theme }) => theme.mobileFirst.breakPoint}) {
    min-height: calc(100vh * 0.21);
    h2 {
      font-size: 1.2em;
      text-align: left;
      padding-top: 2.1em;
      text-align: center;
    }
  }
`;
export const SubMenuObjectiveContainerStyle = styled.div`
  box-sizing: border-box;
  width: 95%;
  margin-left: auto;
  margin-right: auto;
  @media (max-width: ${({ theme }) => theme.mobileFirst.breakPoint}) {
  }
`;
export const SubMenuObjectiveTextStyle = styled.p`
  box-sizing: border-box;
  width: 100%;
  @media (max-width: ${({ theme }) => theme.mobileFirst.breakPoint}) {
  }
`;
export const SubMenuBoxItemContainerStyle = styled.div`
  box-sizing: border-box;
  min-height: 50%;
  height: 100%;
  max-height: 60%;
  width: 100%;
  @media (max-width: ${({ theme }) => theme.mobileFirst.breakPoint}) {
    max-height: initial;
    .boxlist {
      justify-content: flex-start;
    }
  }
`;
export const CloseButtonContainer = styled.div`
  top: 0.1em;
  right: 0.1em;
  position: absolute;
  z-index: 10;
`;
